import React from 'react';
import { connect } from 'react-redux';
import AssistTrip from './AssistTrip.frame';
import * as assistTripActions from './redux/assistTrip.actions';
import { isCar } from '../../../flags/service.flag';

const AssistTripContainer = props => <AssistTrip {...props} />;

function mapStateToProps(state) {
  return {
    isDispatcher: state.user.model.isDispatcher,
    request: state.requests.request,
    completed: state.assistTrip.completed,
    errorMessage: state.assistTrip.errorMessage,
    loading: state.assistTrip.loading,
    isAssisted: state.requests.primaryRequestId || state.requests.assistRequestId,
    isCar: isCar(state.service),
  };
}

export default connect(mapStateToProps, { ...assistTripActions })(AssistTripContainer);
